import { Routes } from "@angular/router";
import { ProfileRoutes } from "./profile.routes";
import { SuppliersRoutes } from "./suppliers.routes";
import { PointOfSaleRoutes } from "./point-of-sale.routes";
import { CustomersRoutes } from "./customers.routes";
import { ProvidersRoutes } from "./providers.routes";
import { InventoryRoutes } from "./inventory.routes";
import { EventRoutes } from "./event.routes";
import { ResourceRoutes } from "./resource.routes";
import { BankRoutes } from "./bank.routes";
import {EmployeeRoutes} from "./employee.routes";
import { StorageLayoutRoutes } from "./storage-layout.routes";

export const MenuRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("../pages/menu/menu.page").then((m) => m.MenuPage),
	},
	{
		path: "video-view",
		loadComponent: () =>
			import("@/app/domains/shared/media/pages/video-view/video-view.page").then((m) => m.VideoViewPage),
	},
	//PERFIL
	{
		path: "profile",
		children: ProfileRoutes,
	},
	/////		RELACIONES Y CONTACTOS		/////

	//CLIENTES
	{
		path: "customers",
		children: CustomersRoutes,
	},
	//PROVEEDORES
	{
		path: "suppliers",
		children: ProvidersRoutes,
	},
	{
		path: "company-verification",
		loadComponent: () =>
			import("@/app/domains/auth/company/verification/pages/company-verification/company-verification.page").then(
				(m) => m.CompanyVerificationPage
			),
	},
	{
		path: "team",
		loadComponent: () =>
			import("@/app/domains/auth/company/team/team.page").then(
				(m) => m.TeamPage
			),
	},
	{
		path: "company-access",
		loadComponent: () =>
			import("@/app/domains/auth/company/pages/company-access/company-access.page").then(
				(m) => m.CompanyAccessPage
			),
	},
	{
		path: "company-edit",
		loadComponent: () =>
			import("@/app/domains/auth/company/pages/company-edit/company-edit.page").then(
				(m) => m.CompanyEditPage
			),
	},
	{
		path: "branch-edit",
		loadComponent: () =>
			import("@/app/domains/auth/company/pages/branch-edit/branch-edit.page").then(
				(m) => m.BranchEditPage
			),
	},
	{
		path: "company-container",
		loadComponent: () =>
			import("@/app/domains/auth/company/pages/company-container/company-container.page").then(
				(m) => m.CompanyContainerPage
			),
	},
	//COLABORADORES
	{
		path: "employee-container",
		children: EmployeeRoutes
		// loadComponent: () =>
		// 	import("@/app/domains/auth/employee/pages/employee-container/employee-container.page").then(
		// 		(m) => m.EmployeeContainerPage
		// 	),
	},
	// {
	// 	path: "employee-container/employee-edit",
	// 	loadComponent: () =>
	// 		import("@/app/domains/auth/employee/pages/employee-edit/employee-edit.page").then(
	// 			(m) => m.EmployeeEditPage
	// 		),
	// },

	/////		INVENTARIOS Y RECURSOS		/////
	//INMUEBLES
	{
		path: "building-container",
		children: StorageLayoutRoutes,
	},

	//Gestion de Inventario
	{
		path: "inventory-management",
		children: InventoryRoutes,
	},
	{
		path: "transfer-container",
		loadComponent: () =>
			import(
				'@/app/domains/erp/transfers/pages/transfer-container/transfer-container.page'
			).then((m) => m.TransferContainerPage),
	},
	{
		path: "transfer-container/transfer-edit",
		loadComponent: () =>
			import('@/app/domains/erp/transfers/pages/transfer-edit/transfer-edit.page').then(
				(m) => m.TransferEditPage
			),
	},
	//BANCO
	{
		path: "bank-management",
		children: BankRoutes,
	},

	//CATEGORIAS
	{
		path: "categories",
		loadComponent: () =>
			import("@/app/domains/resource/categories/pages/categories/categories.page").then((m) => m.CategoriesPage),
	},
	{
		path: "categories/category-edit",
		loadComponent: () =>
			import("@/app/domains/resource/categories/pages/category-edit/category-edit.page").then(
				(m) => m.CategoryEditPage
			),
	},
    {
        path: 'categories/category-edit/attribute-assignment',
        loadComponent: () => import('@/app/domains/resource/attributes/pages/attribute-assignment/attribute-assignment.page').then(m => m.AttributeAssignmentPage)
    },
	//MOVIMIENTO DE INVENTARIOS
	{
		path: "inventory-container",
		loadComponent: () =>
			import(
				'@/app/domains/erp/inventory/pages/inventory-container/inventory-container.page'
			).then((m) => m.InventoryContainerPage),
	},
	//INSUMOS
	{
		path: "main-asset",
		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/main-asset/main-asset.page").then(
				(m) => m.MainAssetPage
			),
	},
	{
		path: "main-asset/resource-edit",

		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/resource-edit/resource-edit.page").then(
				(m) => m.ResourceEditPage
			),
	},
	{
		path: "main-asset/resource-container",

		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/resource-container/resource-container.page").then(
				(m) => m.ResourceContainerPage
			),
	},

	{
		path: "material-list-edit",
		loadComponent: () =>
			import("../pages/material-list-edit/material-list-edit.page").then(
				(m) => m.MaterialListEditPage
			),
	},
	{
		path: "promotion-edit",
		loadComponent: () =>
			import("../domains/marketplace/promotions/pages/promotion-edit/promotion-edit.page").then(
				(m) => m.PromotionEditPage
			),
	},

	{
		path: "main-supply",
		children: SuppliersRoutes,
	},
	////// 		PRODUCTOS Y SERVICIOS		//////
	{
		path: "main-products",
		children: ResourceRoutes,
		// loadComponent: () =>
		// 	import("@/app/domains/resource/catalog/pages/main-products/main-products.page").then(
		// 		(m) => m.MainProductsPage
		// 	),
	},
	{
		path: "main-products/resource-edit",

		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/resource-edit/resource-edit.page").then(
				(m) => m.ResourceEditPage
			),
	},
	{
		path: "main-products/resource-edit/inventory-edit",
		loadComponent: () =>
			import(
				'@/app/domains/erp/inventory/pages/inventory-edit/inventory-edit.page'
			).then((m) => m.InventoryEditPage),
	},
	{
		path: "main-products/resource-container",

		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/resource-container/resource-container.page").then(
				(m) => m.ResourceContainerPage
			),
	},

	/////		 FINANZAS		 /////
	{
		path: "settings",
		loadComponent: () =>
			import("../domains/erp/settings/pages/settings/settings.page").then(
				(m) => m.SettingsPage
			),
	},
	{
		path: "payment-methods-config",
		loadComponent: () =>
			import("../domains/erp/payments/pages/payment-method-config/payment-method-config.page").then(
				(m) => m.PaymentMethodConfigPage
			),
	},
	{
		path: "cheques",
		loadComponent: () =>
			import("../domains/erp/payments/pages/cheque-agenda/cheque-agenda.page").then(
				(m) => m.ChequeAgendaPage
			),
	},
	{
		path: "company-summary",
		loadComponent: () =>
			import("../domains/erp/consolidated/pages/company-summary/company-summary.page").then(
				(m) => m.CompanySummaryPage
			),
	},
	{
		path: "open-accounts",
		loadComponent: () =>
			import("../domains/erp/open-accounts/pages/open-accounts/open-accounts.page").then((m) => m.OpenAccountsPage),
	},
	{
		path: "accounts",
		loadComponent: () =>
			import("../domains/erp/payments/pages/accounts/accounts.page").then(
				(m) => m.AccountsPage
			),
	},
	{
		path: "balance-sheet",
		loadComponent: () =>
			import("@/app/domains/erp/balance-sheet/pages/balance-sheet/balance-sheet.page").then(
				(m) => m.BalanceSheetPage
			),
	},

	/////		NO CATALOGADOS		/////
	{
		path: "reporting-main",
		loadComponent: () =>
			import(
				"../pages/reporting-module/reporting-main/reporting-main.page"
			).then((m) => m.ReportingMainPage),
	},
	{
		path: "checkout-main",
		children: PointOfSaleRoutes,
	},
	{
		path: "promotions",
		loadComponent: () =>
			import("../domains/marketplace/promotions/pages/promotion-container/promotion-container.page").then(
				(m) => m.PromotionContainerPage
			),
	},
	{
		path: "promotions/promotion-edit",
		loadComponent: () =>
			import("../domains/marketplace/promotions/pages/promotion-edit/promotion-edit.page").then(
				(m) => m.PromotionEditPage
			),
	},
	{
		path: "quotations",
		loadComponent: () => import("../domains/erp/quotations/pages/quotations/quotations.page").then((m) => m.QuotationsPage),
	},
	{
		// `new` abre una cotización vacía; si no, el uid de la cotización
		path: "quotations/:uid",
		loadComponent: () =>
			import("../domains/erp/quotations/pages/quotation-edit/quotation-edit.page").then((m) => m.QuotationEditPage),
	},
	{
		path: "loyalty/programs",
		loadComponent: () => import("../domains/loyalty/pages/programs/programs.page").then((m) => m.ProgramsPage),
	},
	{
		path: "loyalty/programs/:uid",
		loadComponent: () =>
			import("../domains/loyalty/pages/program-detail/program-detail.page").then((m) => m.ProgramDetailPage),
	},
	{
		path: "loyalty/redemptions",
		loadComponent: () =>
			import("../domains/loyalty/pages/redemptions/redemptions.page").then((m) => m.RedemptionsPage),
	},
	{
		path: "territory",
		loadComponent: () =>
			import("../pages/territory-tracker/territory-tracker.page").then(
				(m) => m.TerritoryTrackerPage
			),
	},
	{
		path: 'event-main',
		children: EventRoutes
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
